<div class="w-full h-full flex flex-col gap-25 p-5">
  <h2 class="flex flex-col items-center">
    <img src="logo-thalea.svg" class="w-20.5" />
  </h2>

  <div class="h-full flex flex-col items-center justify-center">
    <div class="flex flex-col items-center gap-[1.2rem] w-full sm:w-[25rem]">
      <div class="w-full">
        <h2
          class="text-(--bordeaux-1400) text-center text-xl font-semibold leading-8"
        >
          {{
            checkPasswordStateToShowTab() === "email"
              ? "Hai dimenticato la password?"
              : "Reset password"
          }}
        </h2>

        <p class="text-black text-center text-sm font-normal leading-5">
          {{
            checkPasswordStateToShowTab() === "email"
              ? "Inserisci qui sotto l’email con cui ti sei registrato. Riceverai un codice di conferma nella casella di posta"
              : "Inserisci prima il codice di conferma, poi scegli una nuova password facendo attenzione a soddisfare i criteri minimi"
          }}
        </p>
      </div>

      <hlm-tabs [tab]="checkPasswordStateToShowTab()" class="w-full">
        <form
          hlmTabsContent="email"
          [formGroup]="emailForm"
          (ngSubmit)="sendCodeResetPassword()"
        >
          <section class="flex flex-col gap-[1.2rem]" hlmCard>
            <div
              class="px-5 py-0 pt-5 flex flex-col gap-[1.2rem]"
              hlmCardContent
            >
              <label class="block" hlmLabel>
                Email*
                <hlm-form-field>
                  <input
                    hlmInput
                    class="mt-1.5 w-full"
                    placeholder="Email"
                    type="email"
                    id="email"
                    formControlName="email"
                    placeholder="Inserisci email"
                    autocomplete="off"
                  />
                  <hlm-error
                    >L'email è obbligatoria e deve essere una email
                    valida.</hlm-error
                  >
                </hlm-form-field>
              </label>
            </div>

            <div class="p-5 pt-0" hlmCardFooter>
              <button hlmBtn [disabled]="isLoading()" class="w-full">
                @if (isLoading()) {
                  <hlm-spinner />
                } @else {
                  Invia codice
                }
              </button>
            </div>
          </section>
        </form>

        <form
          hlmTabsContent="password"
          [formGroup]="resetPasswordForm"
          (ngSubmit)="confirmNewPassword()"
        >
          <section class="flex flex-col gap-[1.2rem]" hlmCard>
            <div
              class="px-5 py-0 pt-5 flex flex-col gap-[1.2rem]"
              hlmCardContent
            >
              <label class="block" hlmLabel>
                <!-- Codice* -->
                <hlm-form-field class="mt-1.5 w-full">
                  <input formControlName="code" type="hidden" hlmInput />
                  <brn-input-otp
                    hlm
                    [maxLength]="6"
                    inputClass="disabled:cursor-not-allowed"
                    formControlName="code"
                    [transformPaste]="transformPaste"
                    class="w-full flex justify-center"
                  >
                    <div hlmInputOtpGroup>
                      <hlm-input-otp-slot index="0" />
                      <hlm-input-otp-slot index="1" />
                      <hlm-input-otp-slot index="2" />
                      <hlm-input-otp-slot index="3" />
                      <hlm-input-otp-slot index="4" />
                      <hlm-input-otp-slot index="5" />
                    </div>
                  </brn-input-otp>
                  <hlm-error
                    >Il codice è obbligatorio e deve essere di 6
                    cifre</hlm-error
                  >
                </hlm-form-field>
              </label>

              <label class="block" hlmLabel>
                Password*
                <hlm-form-field class="mt-1.5 w-full">
                  <div class="relative">
                    <input
                      hlmInput
                      class="w-full pr-10"
                      placeholder="Inserisci la password"
                      [type]="showPassword() ? 'text' : 'password'"
                      id="password"
                      formControlName="password"
                      autocomplete="off"
                    />
                    <button
                      type="button"
                      (click)="togglePasswordVisibility()"
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-(--muted-foreground) hover:text-(--foreground) transition-colors"
                      tabindex="-1"
                    >
                      <ng-icon hlm size="sm" [name]="showPassword() ? 'lucideEyeOff' : 'lucideEye'" />
                    </button>
                  </div>
                  <hlm-error>La password è obbligatoria.</hlm-error>

                  <keus-password-requirements
                    [control]="resetPasswordForm.controls.password"
                  ></keus-password-requirements>
                </hlm-form-field>
              </label>

              <label class="block" hlmLabel>
                Conferma Password*
                <hlm-form-field>
                  <div class="relative">
                    <input
                      formControlName="confirmPassword"
                      class="mt-1.5 w-full pr-10"
                      [type]="showConfirmPassword() ? 'text' : 'password'"
                      placeholder="Conferma password"
                      hlmInput
                    />
                    <button
                      type="button"
                      (click)="toggleConfirmPasswordVisibility()"
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-(--muted-foreground) hover:text-(--foreground) transition-colors"
                      tabindex="-1"
                    >
                      <ng-icon hlm size="sm" [name]="showConfirmPassword() ? 'lucideEyeOff' : 'lucideEye'" />
                    </button>
                  </div>
                  <hlm-error
                    >È obbligatoria e deve essere uguale alla
                    password.</hlm-error
                  >
                </hlm-form-field>
              </label>
            </div>

            <div class="p-5 pt-0" hlmCardFooter>
              <button
                hlmBtn
                [disabled]="isLoading()"
                class="w-full"
                onsubmit="confirmNewPassword()"
              >
                @if (isLoading()) {
                  <hlm-spinner />
                } @else {
                  Reset password
                }
              </button>
            </div>
          </section>
        </form>

        <button
          hlmBtn
          variant="link"
          class="w-full text-base"
          [disabled]="isLoading()"
          (click)="onSignInClick()"
          type="button"
        >
          Torna alla login
        </button>
      </hlm-tabs>
    </div>
  </div>
</div>
